/**
 * Color token strings for severity levels in the breakdown bar chart.
 * These are used with useToken to get the actual color values from the theme.
 */
export const SEVERITY_COLOR_TOKENS = {
  high: {
    light: 'red.500',
    dark: 'red.400',
  },
  medium: {
    light: 'yellow.300',
    dark: 'yellow.200',
  },
  low: {
    light: 'teal.400',
    dark: 'teal.300',
  },
} as const;
